import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const FooterLinks = styled.div`
    display: block;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 16px;
    }
`;

export const LinksTitle = styled.p`
    margin-bottom: 12px;
    ${FONTS.H5};
    color: ${COLORS.TextPrimary};
`;

export const LinksList = styled.ul`
    margin: 0;
    padding-left: 0;
    ${FONTS.XS};
`;

export const ListItemLi = styled.li`
    list-style-type: none;
    line-height: 26px;
    margin-bottom: 2px;
    white-space: nowrap;
`;

const ListItem = css`
    cursor: pointer;
    ${FONTS.MediumXS};
    color: ${COLORS.GRAY_DARK};
    line-height: 26px;
    transition: 0.25s;
    
    &:hover {
        color: ${COLORS.TextPrimary};
    }
`;

export const ListItemButton = styled.button`
    text-decoration-line: none;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    text-align: left;
    ${ListItem};
`;

export const ListItemA = styled.a`
    ${ListItem};
`;
